import { useState, useEffect } from 'react';
import { useReadContract } from 'wagmi';
import { formatUnits } from 'viem';

// Chainlink ETH/USD feed on Ethereum mainnet
const chainlinkEthUsdFeed = '0x5f4ec3df9cbd43714fe2740f5e3616155c5b8419';

const chainlinkAbi = [
  {
    inputs: [],
    name: 'latestAnswer',
    outputs: [{ internalType: 'int256', name: '', type: 'int256' }],
    stateMutability: 'view',
    type: 'function',
  },
];

export function useEthToUsd() {
  const [rate, setRate] = useState<number | null>(null);

  const { data: chainlinkPrice } = useReadContract({
    address: chainlinkEthUsdFeed,
    abi: chainlinkAbi,
    functionName: 'latestAnswer',
    watch: true,
  });

  useEffect(() => {
    if (chainlinkPrice) {
      // Chainlink uses 8 decimals for USD feeds
      const price = Number(formatUnits(chainlinkPrice, 8));
      setRate(price);
    } else {
      setRate(3000); // Fallback price if feed fails
    }
  }, [chainlinkPrice]);

  return rate;
}
